// External
import { Fragment, useContext, useEffect, useState } from "react";
import { BiDownload } from "react-icons/bi";

// Internal
import LoadingSpinner from "../UI/LoadingSpinner";
import PowerOfAttorney from "./PowerOfAttorney";
import SignaturePad from "../UI/SignaturePad";
import POA from "../../assets/files/power-of-attorney.pdf";
import { requestPartnerAPI } from "../../api/server";
import { AuthContext } from "../../context/auth-context";
import { uploadBase64String } from "../../util/uploadBase64String";
import Heading from "../UI/Heading";
import { useSearchParams } from "react-router-dom";
import { MdDownload } from "react-icons/md";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { UtilityContext } from "../../context/util-context";

/** ========================================================================
 * * Sign Power of Attorney Component
 * Renders a form to sign the Power of Attorney for a vehicle.
 * ========================================================================== */

export default function SignVehiclePOA() {
  const { user } = useContext(AuthContext);
  const { navigate } = useContext(UtilityContext);

  // Get ID from URL
  const [searchParams] = useSearchParams();
  const vin = searchParams.get("vin");

  // Initialize States
  const [loading, setLoading] = useState(true);
  const [vehicle, setVehicle] = useState();

  // ========================================== FETCH VEHICLE
  const fetchVehicleHandler = async () => {
    try {
      setLoading(true);
      const data = await requestPartnerAPI("fetch-vehicle", { vin: vin });
      setVehicle(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  // ========================================== SIGN POWER OF ATTORNEY
  const submitHandler = async (signature) => {
    try {
      setLoading(true);
      const signatureURL = await uploadBase64String(
        `partners/${user.uid}/signature`,
        signature
      );
      const url = await requestPartnerAPI("generate-poa", {
        vehicleId: vin,
        signature: signatureURL,
      });
      navigate(`/vehicles/info?vin=${vin}`);
      setLoading(false);
    } catch (err) {
      console.error(err.message);
      setLoading(false);
    }
  };

  // Fetch Vehicle on load
  useEffect(() => {
    fetchVehicleHandler();
  }, []);

  if (!vin) return <div className="bg">
    <p>VIN not provided!</p>
  </div>

  return (
    <div className="grid gap-4 bg">
      <Heading
        isBackArrow={true}
        title="Sign Power Of Attorney"
        description="Please read the Power of Attorney document carefully and scroll to the bottom to sign. Once signed, you will be able to download the signed document."
      >
        <a
          href={POA}
          download="power-of-attorney-template.pdf"
          target="blank"
          rel="noopener noreferrer"
          className="flex items-center p-2 space-x-2 btn-secondary"
        >
          <p className="hidden text-sm text-stone-200 md:block">
            Download Template
          </p>
          <MdDownload className="text-xl text-stone-200" />
        </a>
      </Heading>

      {loading ? (
        <LoadingSpinnerWrapper />
      ) : (
        <Fragment>
          <p className="font-semibold text-white md:text-lg">
            {vehicle?.year} {vehicle?.make} {vehicle?.model} - {vehicle?.vin}
          </p>

          <div className="h-full px-2 py-4 overflow-scroll border border-yellow-600 rounded-md">
            <div className="grid gap-6">
              <PowerOfAttorney vehicle={vehicle} />
              <hr className="hr" />
              <SignaturePad setSignature={submitHandler} />
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
}
